// Shared fixed widths so the campaign table and its per-post rows align column-for-column.
export const COLUMN_WIDTHS = {
    expand: 48,
    title: 340,
    locations: 300,
    platforms: 150,
    scheduledTime: 170,
    status: 160,
    actions: 150,
};

export const TABLE_MIN_WIDTH = Object.values(COLUMN_WIDTHS).reduce((sum, w) => sum + w, 0);
